// extracted by mini-css-extract-plugin
export var active = "_dh-7";
export var blink = "_dh-8";
export var dropDownSelector = "_dh-4";
export var dropDownWrapper = "_dh-3";
export var fakeCursor = "_dh-6";
export var fontSizeButton = "_dh-9";
export var formQuillEditor = "_dh-0";
export var pressed = "_dh-a";
export var qlBlank = "_dh-1";
export var textFormattingToolbar = "_dh-2";
export var textToolbarOption = "_dh-5";